import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Decision = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">
    Decisions    </h2>
    <hr />
   
      <p className="joab-common-para my-4 ">
      All Articles will normally go through at least one round of review, sometimes an extra revision is needed then a second or very limited a third revision of the manuscript is required.      </p>
      <p className="joab-common-para my-2 ">
      Following decision are made on a manuscript:
      </p>
      <ul className="joab-common-para my-2">
        <li>
        The paper is accepted for publication without any further changes required from the authors.
        </li>
        <li>
        The paper is accepted for publication in principle once the authors have made some revisions in response to the referees’ comments (minor or major revision). Under these circumstances, often further experiments or technical work are usually required to address some or all of the referees’ concerns, and revised papers are sent back to some or all of the referees for a second opinion. Revised papers should be accompanied by a point-by-point response to all the comments made by all the referees.
        </li>
        <li>
        The paper is rejected with no offer to reconsider a resubmitted version. Under these circumstances, authors are strongly advised not to resubmit a revised version as it will be declined without further review. If the authors feel that they have a strong scientific case for reconsideration (if the referees have missed the point of the paper, for example) they can appeal the decision in writing.
        </li>
      </ul>

      <p className="joab-common-para my-4 ">
      In replying to the referees’ comments, authors are advised to use language that would not cause offence when their paper is shown again to the referees, and to bear in mind that if a point was not clear to the referees and/or editors, it is unlikely that it would be clear to the readers of the journal.

</p>

  </Container>
  );
};

export default Decision;
